import { Dashboard, Person, Event } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getMyPageSetting } from 'src/shared/functions/getMyPageSetting';
import { MyPageSettingsEnum } from 'src/shared/models/enums/myPageSettings.enum';
import { MeRoutesEnum } from 'src/shared/models/enums/routes.enum';
import { SysProductYvNameEnum } from 'src/shared/models/enums/sysProductEnums';
import { MemberSideMenuItem } from 'src/shared/models/gui/memberSideMenuItem';

export const useSideMenuMember = () => {
  const { currentMember, currentUser } = useGlobals();
  const [enableEvent, setEnableEvent] = useState<boolean>(false);

  useEffect(() => {
    if (currentMember) {
      setEnableEvent(currentMember.enableEvent);
    } else if (currentUser) {
      const hasEvent = !!getMyPageSetting(currentUser, MyPageSettingsEnum.EnableEvent, 'false');
      setEnableEvent(hasEvent);
    }
  }, [currentMember, currentUser]);

  const sideMenuMemberItems: MemberSideMenuItem[] = [
    {
      yvName: SysProductYvNameEnum.MemberReg,
      key: 'dashboard-member',
      showMenuItem: true,
      label: 'sideMenu.dashboard',
      link: MeRoutesEnum.MemberDashboard,
      Icon: <Dashboard />,
    },
    {
      yvName: SysProductYvNameEnum.MemberReg,
      key: 'my-profile',
      showMenuItem: true,
      label: 'sideMenu.myPage',
      link: MeRoutesEnum.MemberMyPage,
      Icon: <Person />,
    },
    {
      yvName: SysProductYvNameEnum.Event,
      key: 'events',
      showMenuItem: enableEvent,
      label: 'sideMenu.events',
      link: MeRoutesEnum.MemberEvents,
      Icon: <Event />,
    },
  ];

  return sideMenuMemberItems;
};
